/*
 * @author  Agence Dn'D <contact@dnd.fr>
 * @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
 * @link    https://www.dnd.fr/
 */

// Reveal the button once the user has scrolled past the first viewport height
if (!customElements.get('sticky-button')) {
  customElements.define(
    'sticky-button',
    class StickyButton extends HTMLElement {
      constructor() {
        super();
        this.ticking = false;
        this.onScroll = this.onScroll.bind(this);
      }

      connectedCallback() {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      }

      update() {
        this.classList.toggle('is-visible', window.scrollY > window.innerHeight / 1.5);
      }
    }
  );
}
